import { formatDateTime, formatNumber, getClassForPositiveNegativeValue } from "../../misc/helperfunctions";
import {
    Typography, Tooltip, Box, Button
} from "@mui/material";
import { Link } from "react-router-dom";

const STRATEGY_CYCLE = ['longterm', 'growth', 'dividend'];
const STRATEGY_LABELS = { growth: 'Growth', dividend: 'Dividende', longterm: 'Langfrist' };
const STRATEGY_COLORS = { growth: '#2196f3', dividend: '#ff9800', longterm: '#9c27b0' };

export function getStockcolumns({ onStrategyChange } = {}) {

    const columns = [
        // field 'identifier' to add by the caller
        // field 'name' to add by the caller
        {
            field: "quantity",
            headerName: "Bestand",
            width: 100,
            type: "number",
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value);
                return `${valueFormatted}`;
            },
        },
        {
            field: "close",
            headerName: "Kurs",
            width: 90,
            type: "number",
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value);
                return `${valueFormatted}`;
            },
        },
        {
            field: "currencycode",
            headerName: "Currency",
            width: 60,
        },
        {
            field: "profit_1d",
            headerName: "Abs. Perf. 1d",  // Performance 1 day
            width: 100,
            type: "number",
            cellClassName: (params) => {
                return getClassForPositiveNegativeValue(params);
            },
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value);
                return `${valueFormatted}`;
            },
        },
        {
            field: "change_p",
            headerName: "Change %",
            width: 90,
            type: "number",
            cellClassName: (params) => {
                return getClassForPositiveNegativeValue(params);
            },
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value);
                return `${valueFormatted}`;
            },
        },
        {
            field: "pricedate",
            headerName: "Kursdatum",
            width: 140,
            type: "date",
            valueFormatter: (params) => {
                const valueFormatted = formatDateTime(params.value);
                return `${valueFormatted}`;
            },
        },
        {
            field: "ttwror30",
            headerName: "Perf. 1M",
            width: 80,
            type: "number",
            description:
                'TTWROR 30 (Performance 1 Monat): 30 Tage Time Weighted Return on Risk. Prozentuale Veränderung der letzten 30 Tage.',
            cellClassName: (params) => {
                return getClassForPositiveNegativeValue(params);
            },
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value);
                return `${valueFormatted}`;
            },
        },
        {
            field: "total_buy_price",
            headerName: "Einstandspreis",
            width: 120,
            type: "number",
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value);
                return `${valueFormatted}`;
            },
        },
        {
            field: "total_market_price",
            headerName: "Marktwert",
            width: 120,
            type: "number",
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value);
                return `${valueFormatted}`;
            },
        },
        {
            field: "profit",
            headerName: "Gewinn/Verlust",
            width: 120,
            type: "number",
            cellClassName: (params) => {
                return getClassForPositiveNegativeValue(params);
            },
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value);
                return `${valueFormatted}`;
            },
        },
        {
            field: "abs_performance",
            headerName: "Abs. Performance",
            width: 140,
            type: "number",
            description:
                'Kursgewinne + Realisierte Gewinne + Brutto Dividende - Steuer in EUR',
            cellClassName: (params) => {
                return getClassForPositiveNegativeValue(params);
            },
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value);
                return `${valueFormatted}`;
            },
        },
        {
            field: "abs_performance_p",
            headerName: "Abs.Perf.%",
            width: 90,
            type: "number",
            cellClassName: (params) => {
                return getClassForPositiveNegativeValue(params);
            },
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value);
                return `${valueFormatted}`;
            },
        },
        {
            field: "dividends_brutto_total",
            headerName: "∑ Dividenden",
            width: 120,
            type: "number",
            description:
                'Summe aller Dividenden (Brutto) in EUR',
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value);
                return `${valueFormatted}`;
            },
        },
        {
            field: "dividend_yield_total",
            headerName: "Div % total",
            width: 90,
            type: "number",
            description:
                'Dividendenertrag gesamt in %',
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value);
                return `${valueFormatted}`;
            },
        },
        {
            field: "dividendyield",
            headerName: "Div % aktuell",
            width: 90,
            type: "number",
            description:
                'Dividendenrendite aktuell (bei Neuerwerb an Börse)',
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value);
                return `${valueFormatted}`;
            },
        },
        {
            field: "owner_dividend_yield",
            headerName: "Eigene DivRend. %",
            width: 90,
            type: "number",
            description:
                'Eigene Dividendenrendite bezogen auf den Einstandskurs und die Ausschüttung pro Jahr',
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value);
                return `${valueFormatted}`;
            },
        },
        {
            field: "total_gross_dividend_in_eur",
            headerName: "Div pro Jahr €",
            width: 100,
            type: "number",
            description:
                'Brutto Ausschüttungen pro Jahr in € bezogen auf den heutigen Bestand und die zur erwartende Ausschüttung',
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value);
                return `${valueFormatted}`;
            },
        },
        {
            field: "strategy",
            headerName: "Strategie",
            width: 90,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                const val = params.value || 'longterm';
                const handleClick = (e) => {
                    if (!onStrategyChange) return;
                    e.stopPropagation();
                    const idx = STRATEGY_CYCLE.indexOf(val);
                    const next = STRATEGY_CYCLE[(idx + 1) % STRATEGY_CYCLE.length];
                    onStrategyChange(params.row.identifier, next);
                };
                return (
                    <Tooltip title={onStrategyChange ? 'Klick zum Wechseln' : ''} arrow>
                        <Box
                            onClick={handleClick}
                            sx={{
                                backgroundColor: STRATEGY_COLORS[val] || '#9e9e9e', color: '#fff',
                                borderRadius: '4px', padding: '2px 6px',
                                fontSize: '0.75rem', fontWeight: 'bold',
                                cursor: onStrategyChange ? 'pointer' : 'default',
                                '&:hover': onStrategyChange ? { opacity: 0.8 } : {},
                            }}>
                            {STRATEGY_LABELS[val] || val}
                        </Box>
                    </Tooltip>
                );
            },
        },
        {
            field: "signal",
            headerName: "Ampel",
            width: 60,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                const { value } = params;
                const colorMap = { GREEN: '#4caf50', YELLOW: '#ff9800', RED: '#f44336' };
                const color = colorMap[value] || '#9e9e9e';
                return (
                    <Tooltip title={value || 'Kein Signal'} arrow>
                        <Box sx={{
                            width: 20, height: 20, borderRadius: '50%',
                            backgroundColor: color,
                            border: '2px solid rgba(255,255,255,0.3)',
                        }} />
                    </Tooltip>
                );
            },
        },
        {
            field: "portfolio_action_score",
            headerName: "Score",
            width: 70,
            type: "number",
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                const score = params.value;
                if (score == null) return '';
                const colorMap = { GREEN: '#4caf50', YELLOW: '#ff9800', RED: '#f44336' };
                const signal = params.row.signal;
                const bgColor = colorMap[signal] || '#9e9e9e';
                return (
                    <Box sx={{
                        backgroundColor: bgColor, color: '#fff',
                        borderRadius: '4px', padding: '2px 8px',
                        fontWeight: 'bold', fontSize: '0.85rem',
                    }}>
                        {Math.round(score)}
                    </Box>
                );
            },
        },
        {
            field: "score_delta",
            headerName: "Δ",
            width: 60,
            type: "number",
            align: "center",
            headerAlign: "center",
            description: 'Score-Veränderung zur Vorwoche',
            renderCell: (params) => {
                const delta = params.value;
                if (delta == null) return '';
                const color = delta > 0 ? '#4caf50' : delta < 0 ? '#f44336' : '#9e9e9e';
                const prefix = delta > 0 ? '+' : '';
                return (
                    <Typography variant="body2" sx={{ color, fontWeight: 'bold' }}>
                        {prefix}{Math.round(delta)}
                    </Typography>
                );
            },
        },
        {
            field: "ai_response_short",
            headerName: "KI Rank",
            width: 90,
            renderCell: (params: GridCellParams) => {
                const { value } = params;

                // Hintergrundfarbe in Abhängigkeit vom Zellwert festlegen
                let backgroundColor;
                if (value === "Kaufen") {
                    backgroundColor = "green";
                } else if (value === "Verkaufen") {
                    backgroundColor = "red";
                } else {
                    backgroundColor = "grey"; // Standard-Hintergrund
                }

                // Stil für die Zelle
                const buttonStyle = {
                    backgroundColor,
                    color: "white", // Weißer Text für besseren Kontrast
                    borderRadius: "4px", // Optional: Abgerundete Kanten für besseren Stil
                    padding: "4px", // Optional: Innenabstand
                    textAlign: "center",
                    width: "100%",
                };

                // Zellinhalt rendern als Link/Buttton
                return (
                    <Button sx={buttonStyle} color="inherit" variant="outlined" size="small" component={Link}
                        to={{
                            pathname: "/aiAnalyser",
                        }}
                        state={{ identifier: params.row.identifier }}
                    >
                        {value}
                    </Button>
                );
            },
        },
        {
            field: "ai_score",
            headerName: "KI Score",
            width: 60,
        },
        {
            field: "current_ranking",
            headerName: "Pos.",
            width: 40,
            type: "number",
            align: "center",        // Inhalt in der Zelle zentrieren
            headerAlign: "center"   // Spaltenüberschrift zentrieren
        },
        {
            field: "last_week_ranking",
            headerName: "Last Week",
            width: 80,
            type: "number",
            align: "center",
            headerAlign: "center",
            renderCell: (params: GridCellParams) => {
                const { current_ranking, last_week_ranking } = params.row;
                if (current_ranking == null || last_week_ranking == null) return '';

                // Veränderung berechnen
                const difference = current_ranking - last_week_ranking;

                // Festlegen von Icon und Farbe in Abhängigkeit zur Veränderung
                let icon;
                let color;
                let diffString;

                if (difference < 0) {
                    icon = '↑';             // Ranking ist besser geworden (kleinere Zahl)
                    color = 'green';
                    diffString = `+${Math.abs(difference)}`;
                } else if (difference > 0) {
                    icon = '↓';             // Ranking ist schlechter geworden (größere Zahl)
                    color = 'red';
                    diffString = `-${difference}`;
                } else {
                    icon = '→';             // Keine Veränderung
                    color = 'gray';
                    diffString = '±0';
                }

                // Text für den Tooltip vorbereiten
                const tooltipText = `Veränderung zur Vorwoche: ${diffString}`;

                return (
                    <Tooltip title={tooltipText} arrow>
                        <Box display="flex" alignItems="center" gap={0.5}>
                            <Typography variant="body2">{last_week_ranking}</Typography>
                            <Typography variant="body2" style={{ color }}>
                                {icon}
                            </Typography>
                        </Box>
                    </Tooltip>
                );
            },
        }

    ];

    return columns;
}

